export default __webpack_public_path__ + "static/media/generic.e5c13784.svg";